export default "__VITE_ASSET__BiZGSWxm__"